import { useMemo } from 'react';
import { mikaela } from '@/data/samples/mikaela';
import {
  abilityDemos,
  scenarios,
  traits,
  cheatRows,
  combatBlock,
} from '@/data/samples/mikaela-playbook';
import { SectionEyebrow } from '@/components/ui/SectionEyebrow';
import { StickyNav } from '@/features/playbook/StickyNav';
import { CharacterCore } from '@/features/playbook/CharacterCore';
import { CheatStrip } from '@/features/playbook/CheatStrip';
import { AbilityCard } from '@/features/playbook/AbilityCard';
import { ScenarioCard } from '@/features/playbook/ScenarioCard';
import { TraitSection } from '@/features/playbook/TraitSection';
import { AbilityJumpNav } from '@/features/playbook/AbilityJumpNav';
import { BackToTop } from '@/features/playbook/BackToTop';

const SECTIONS = [
  { id: 'sheet', label: 'Sheet' },
  { id: 'cheat', label: 'Cheat' },
  { id: 'abilities', label: 'Abilities' },
  { id: 'scenarios', label: 'Scenarios' },
  { id: 'traits', label: 'Traits' },
];

export function MikaelaPage() {
  const abilityLookup = useMemo(
    () => new Map(abilityDemos.map((d) => [d.slug, d])),
    []
  );

  return (
    <div className="relative mx-auto max-w-3xl px-6 pt-28 pb-20">
      <SectionEyebrow start>· Mikaela's Playbook ·</SectionEyebrow>
      <h1 className="display-title is-start mb-2">
        <em>Mikaela</em>
      </h1>
      <p className="section-lede is-start">
        Her whole toolkit on one scrollable page. Cheat strip for the 80% rolls, a card per
        ability with a table-ready scene, ten scenarios when you're not sure what to reach for,
        and the traits that shape how she acts.
      </p>

      <StickyNav sections={SECTIONS} />

      <section id="sheet" className="scroll-mt-28 mb-10">
        <h2 className="section-title">The Sheet</h2>
        <CharacterCore c={mikaela} />
      </section>

      <section id="cheat" className="scroll-mt-28 mb-10">
        <h2 className="section-title">Cheat Strip</h2>
        <CheatStrip rows={cheatRows} combat={combatBlock} />
      </section>

      <section id="abilities" className="scroll-mt-28 mb-10">
        <h2 className="section-title">Abilities ({abilityDemos.length})</h2>
        <AbilityJumpNav demos={abilityDemos} />
        <div className="space-y-3">
          {abilityDemos.map((demo) => (
            <AbilityCard key={demo.slug} demo={demo} />
          ))}
        </div>
      </section>

      <section id="scenarios" className="scroll-mt-28 mb-10">
        <h2 className="section-title">Scenarios ({scenarios.length})</h2>
        <div className="space-y-3">
          {scenarios.map((s) => (
            <ScenarioCard key={s.slug} scenario={s} abilityLookup={abilityLookup} />
          ))}
        </div>
      </section>

      <section id="traits" className="scroll-mt-28 mb-10">
        <h2 className="section-title">Traits, Flaws & Personality</h2>
        <TraitSection traits={traits} />
      </section>
      <BackToTop />
    </div>
  );
}
